export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('INDEX.log_label_operationDesc') || '业务说明',
    field: 'operationDesc',
    width: 300,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'descShowType',
    },
  },
  {
    title: that.$l('INDEX.log_label_operationBy') || '操作人',
    field: 'operationByName',
    width: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.log_label_operationTime') || '操作时间',
    field: 'operationTime',
    width: 170,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.log_label_linkData') || '操作备注',
    field: 'linkData',
    minWidth: 450,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
